/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Canale di comunicazione (email, SMS, WhatsApp, notifica push)
 */
export enum CanaleComunicazione {

    EMAIL = 'EMAIL',

    SMS = 'SMS',

    WA = 'WA',

    PUSH = 'PUSH'
}

